import axiosInstance from "../api";
import {
  GET_ACTIVE_CONTEST,
  GET_CONTEST,
  GET_CONTEST_BY_ID,
  GET_CONTEST_COMMENT_LIST,
  GET_CONTEST_ENTRY_LIST,
  GET_COMPLETE_CONTEST,
  GET_PROPOSED_CONTEST,
  GET_MYOREDR_CONTEST,
  GET_CONTEST_PUBLIC_COMMENT,
  GET_CONTEST_PROPOSAL_BY_ID,
  GET_CONTEST_CHILD_PUBLIC_COMMENT,
  GET_CONTEST_MODEL_COMMENT,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { getPostsById } from "../posts/action";
import { getRentalRequestById } from "../rental/action";

export const getContestList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post`);
    if (response?.data?.status) {
      dispatch({ type: GET_CONTEST, getcontestlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestProposalbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal/id?id=${id}&type=4`);
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_PROPOSAL_BY_ID,
        getcontestpropsalbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMyOrderContestList =
  (type, pagenumber, size, status) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `post?type=${type}&is_mine=1&index=${pagenumber}&size=${size}&status=${status}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_MYOREDR_CONTEST,
          myordercontestlist: response?.data,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const getContestActiveList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=11`);
    if (response?.data?.status) {
      dispatch({
        type: GET_ACTIVE_CONTEST,
        getcontestactivelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestCompletedList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=12`);
    if (response?.data?.status) {
      dispatch({
        type: GET_COMPLETE_CONTEST,
        getcontestcompletelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestEntryList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `proposal?type=2&post_id=3&index=0&size=12&sort=1`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_ENTRY_LIST,
        getcontestentrylist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestCommentList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `comment?type=2&comment_id=1&index=0&size=5`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_COMMENT_LIST,
        getcontestcommentlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const postContestEntry =
  (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("proposal/create", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        navigate(data?.url, {
          state: { response: response?.data?.response, type: "contest" },
        });
        return;
      }
      console.error();
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const postContestComment = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("comment", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostsById(data?.post_id));
      dispatch(getContestPublicComment(data?.post_id, data?.size));
      dispatch(getContestReplyChildComment(data?.comment_id));
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const postModelComment = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("comment", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getContestProposalComment(data?.proposal_id));
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const addContest = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("post", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getContestById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_BY_ID,
        getcontestbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestPublicComment = (id, size) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `comment?type=1&post_id=${id}&index=0&&size=${size ? size : 5}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_PUBLIC_COMMENT,
        getcontestpubliccommentlist: response?.data,
      });
    }
    return response?.data;
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestReplyChildComment = (id, size) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `comment?type=2&comment_id=${id}&index=0&size=${size ? size : 5}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_CHILD_PUBLIC_COMMENT,
        getcontestpublicchildcommentlist: response.data,
      });
      return response?.data?.response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getContestProposalComment = (id, size) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `comment?type=3&proposal_id=${id}&index=0&size=${size ? size : 5}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CONTEST_MODEL_COMMENT,
        getcontestmodelcommentlist: response.data,
      });
      return response?.data?.response;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const likeContest = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("like", data);
    if (response?.data?.status) {
      dispatch(getPostsById(data?.post_id));
      dispatch(getContestProposalbyid(data?.proposal_id));
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      // window.location.reload()
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const rateContest = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("rating", data);
    if (response?.data?.status) {
      dispatch(getPostsById(data?.post_id));
      dispatch(getContestProposalbyid(data?.proposal_id));
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    // console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const awardContest = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const handoverawardContest = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostsById(data?.post_id));

      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const approveSubmissionContest =
  (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("proposal/update", data);
      if (response?.data?.status) {
        dispatch(getPostsById(data?.post_id));
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        // window.location.reload();
        return;
      }
      console.error();
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error();
      //urtoast(err.message, 2);
    }
  };

export const getContestPraposedData =
  (post_id, sort, pagenumber, size) => async (dispatch) => {
    try {
      const response = await axiosInstance.get(
        `proposal?type=2&post_id=${post_id}&sort=${sort}&index=${pagenumber}&size=${size}`
      );
      if (response?.data?.status) {
        dispatch({
          type: GET_PROPOSED_CONTEST,
          getproposalcontestlist: response?.data?.response,
        });
        return;
      }
      urtoast(response?.data?.response?.message, 2);
    } catch (err) {
      //urtoast(err.message, 2);
    }
  };

export const contestEntryView = (post_id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `proposal/id?id=${post_id}&type=4`
    );
    if (response?.data?.status) {
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const overallRatings = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("rating", data);
    if (response?.data?.status) {
      if (data?.type == 5) {
        dispatch(getRentalRequestById(data?.post_id));
      } else {
        dispatch(getPostsById(data?.post_id));
      }
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    // console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};
